import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmDialogModule } from '@portal-core/general/components/confirm-dialog/confirm-dialog.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { PermissionsTreeModule } from '@portal-core/permissions/components/permissions-tree/permissions-tree.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { PermissionsFormComponent } from './permissions-form.component';

@NgModule({
  declarations: [PermissionsFormComponent],
  imports: [
    McColorModule,
    CommonModule,
    ConfirmDialogModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSnackBarModule,
    PermissionsTreeModule,
    ProjectAvatarModule,
    ProjectAsyncModule
  ],
  exports: [PermissionsFormComponent]
})
export class PermissionsFormModule { }
